/**
 * Hidden inline SVG that defines the CRT-tube barrel clip path.
 *
 * Path traces the bbox with quadratic Beziers whose control points sit slightly
 * OUTSIDE the box, so each edge bows outward while the corners stay at the
 * rectangle vertices (visually sharp). `clipPathUnits="objectBoundingBox"`
 * makes the coordinates 0–1 relative to the element it's applied to, so the
 * shape scales with the tube.
 *
 * Apply with: clip-path: url(#crt-barrel)
 *
 * Bump the bow (currently 0.025 = 2.5% beyond each edge) for a stronger bulge,
 * or drop it for subtler.
 */
const BOW = 0.028;

const path = [
  `M 0,0`,
  `Q 0.5,${-BOW} 1,0`,
  `Q ${1 + BOW},0.5 1,1`,
  `Q 0.5,${1 + BOW} 0,1`,
  `Q ${-BOW},0.5 0,0`,
  `Z`,
].join(" ");

export function CRTBarrelClip() {
  return (
    <svg
      width="0"
      height="0"
      style={{ position: "absolute", overflow: "hidden" }}
      aria-hidden
    >
      <defs>
        <clipPath id="crt-barrel" clipPathUnits="objectBoundingBox">
          <path d={path} />
        </clipPath>
      </defs>
    </svg>
  );
}
